(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const copy = JSON.parse($('#PhytoExpansionUI')?.textContent || '{}');
  const routes = JSON.parse($('#PhytoRoutes')?.textContent || '{}');
  const catalog = JSON.parse($('#PhytoCatalog')?.textContent || '[]');
  const escape = value => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money = value => new Intl.NumberFormat(routes.locale || document.documentElement.lang, {style:'currency',currency:routes.currency || 'EUR'}).format(value / 100);
  const format = (text, values) => Object.entries(values).reduce((result, [key, value]) => result.replaceAll('{'+key+'}', value), text || '');
  const getSize = variant => Number(variant.title.match(/\d+/)?.[0] || 0);

  const languageForm = $('#HeaderLanguage');
  languageForm?.addEventListener('submit', () => {
    let input = $('input[name="return_to"]', languageForm);
    if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'return_to'; languageForm.append(input); }
    input.value = location.pathname + location.search;
  });

  const builder = $('[data-set-builder]');
  if (builder) {
    const text = copy.bundle;
    const selection = new Map();
    const active = new Map();
    let submitting = false;
    const summary = $('.set-summary', builder);
    const productFor = variantId => {
      for (const product of catalog) {
        const variant = product.variants.find(v => String(v.id) === String(variantId));
        if (variant) return {product, variant};
      }
      return null;
    };
    const render = () => {
      const lines = [...selection].map(([id, quantity]) => ({...productFor(id), id, quantity})).filter(line => line.product);
      const count = lines.reduce((sum, line) => sum + line.quantity, 0);
      const subtotal = lines.reduce((sum, line) => sum + line.variant.price * line.quantity, 0);
      const discount = count >= 3 ? lines.reduce((sum, line) => sum + Math.floor(line.variant.price * line.quantity / 5), 0) : 0;
      $('[data-set-reset]', summary).hidden = count === 0;
      $('[data-set-progress-label]', summary).textContent = count === 0 ? text.start : count < 3 ? format(text.remaining, {count:3-count}) : text.unlocked;
      const progress = $('[data-set-progress]', summary);
      progress.setAttribute('aria-valuenow', String(Math.min(count, 3)));
      $('span', progress).style.width = Math.min(count / 3, 1) * 100 + '%';
      $('[data-set-lines]', summary).innerHTML = lines.length ? lines.map(line => `<div class="set-line"><img src="${escape(line.product.image)}" alt="" width="54" height="72"><div class="set-line-copy"><h3>${escape(line.product.name)}</h3><p>${escape(line.variant.title)} · ${money(line.variant.price)}</p><div class="set-line-quantity"><button type="button" data-set-step="-1" data-set-variant="${line.id}" aria-label="${escape(text.decrease+' '+line.product.name+' '+line.variant.title)}">−</button><span aria-label="${line.quantity}">${line.quantity}</span><button type="button" data-set-step="1" data-set-variant="${line.id}" aria-label="${escape(text.increase+' '+line.product.name+' '+line.variant.title)}" ${line.quantity>=20?'disabled':''}>+</button><button type="button" class="set-line-remove" data-set-remove="${line.id}">${escape(text.remove)}</button></div></div><strong>${money(line.variant.price*line.quantity)}</strong></div>`).join('') : `<p class="set-empty">${escape(text.empty)}</p>`;
      $('[data-set-subtotal]', summary).textContent = money(subtotal);
      $('[data-set-discount]', summary).textContent = discount ? '−'+money(discount) : money(0);
      $('[data-set-discount-label]', summary).textContent = discount ? '20%' : '';
      $('[data-set-total]', summary).textContent = money(subtotal-discount);
      const submit = $('[data-set-submit]', summary);
      submit.disabled = count < 3 || submitting;
      submit.textContent = submitting ? text.pending : text.add_set;
      const sizes = [...new Set(lines.map(line => getSize(line.variant)))];
      const distinctProducts = new Set(lines.map(line => line.product.key));
      const kit = catalog.find(product => product.key === 'kit');
      const kitVariant = kit?.variants.find(v => getSize(v) === sizes[0] && v.available);
      const sameAsKit = lines.length === 4 && count === 4 && distinctProducts.size === 4 && !distinctProducts.has('kit') && sizes.length === 1 && kitVariant && kitVariant.price < subtotal-discount;
      $('[data-set-kit]', summary).hidden = !sameAsKit;
      if (sameAsKit) {
        $('[data-set-kit-copy]', summary).textContent = format(text.kit_note, {price:money(kitVariant.price)});
        $('[data-set-kit-link]', summary).href = kit.url+'?variant='+kitVariant.id;
      }
      $$('[data-set-product]', builder).forEach(card => {
        const chosen = active.get(card.dataset.setProduct);
        const add = $('[data-set-add]', card);
        add.disabled = !chosen || submitting || (selection.get(String(chosen.id)) || 0) >= 20;
      });
    };
    builder.addEventListener('click', event => {
      if (submitting) return;
      const option = event.target.closest('[data-set-size]');
      if (option) {
        const card = option.closest('[data-set-product]');
        const found = productFor(option.dataset.setSize);
        if (!found?.variant.available) return;
        active.set(card.dataset.setProduct, found.variant);
        $$('[data-set-size]', card).forEach(button => button.setAttribute('aria-pressed', String(button === option)));
        $('[data-set-unit-price]', card).textContent = money(found.variant.price);
        render();
      }
      const add = event.target.closest('[data-set-add]');
      if (add && !add.disabled) {
        const card = add.closest('[data-set-product]');
        const variant = active.get(card.dataset.setProduct);
        if (!variant?.available) return;
        const id = String(variant.id);
        selection.set(id, Math.min(20, (selection.get(id) || 0)+1));
        $('[data-set-error]', summary).textContent = '';
        render();
      }
      const step = event.target.closest('[data-set-step]');
      if (step) {
        const id = step.dataset.setVariant;
        const next = Math.max(0, Math.min(20, (selection.get(id) || 0) + Number(step.dataset.setStep)));
        if (next) selection.set(id, next); else selection.delete(id);
        render();
      }
      const remove = event.target.closest('[data-set-remove]');
      if (remove) { selection.delete(remove.dataset.setRemove); render(); }
      if (event.target.closest('[data-set-reset]')) { selection.clear(); render(); }
    });
    $('[data-set-submit]', summary).addEventListener('click', async event => {
      if (submitting || [...selection.values()].reduce((a,b)=>a+b,0) < 3) return;
      const items = [...selection].map(([id, quantity]) => ({id:Number(id), quantity}));
      submitting = true;
      $('[data-set-error]', summary).textContent = '';
      render();
      try {
        if (!window.PhytoHealCart?.add) throw new Error(text.error);
        await window.PhytoHealCart.add(items, event.currentTarget);
        selection.clear();
      } catch (error) { $('[data-set-error]', summary).textContent = error.message || text.error; }
      finally { submitting = false; render(); }
    });
    render();
  }

  const journal = $('[data-journal]');
  if (journal) {
    let category = 'all';
    const search = $('[data-journal-search]', journal);
    const filter = () => {
      const query = (search?.value || '').toLocaleLowerCase().trim();
      let visible = 0;
      $$('[data-journal-card]', journal).forEach(card => {
        const matchesCategory = category === 'all' || card.dataset.journalCategory === category;
        const matchesText = !query || card.textContent.toLocaleLowerCase().includes(query);
        card.hidden = !(matchesCategory && matchesText);
        if (!card.hidden) visible++;
      });
      $('[data-journal-empty]', journal).hidden = visible > 0;
    };
    $$('[data-journal-filter]', journal).forEach(button => button.addEventListener('click', () => {
      category = button.dataset.journalFilter;
      $$('[data-journal-filter]', journal).forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      filter();
    }));
    search?.addEventListener('input', filter);
  }

  const film = $('[data-studio-film-dialog]');
  if (film) {
    const video = $('video', film);
    let filmOpener;
    $('[data-studio-film-open]')?.addEventListener('click', event => {
      filmOpener = event.currentTarget;
      if (!video.src) video.src = filmOpener.dataset.studioFilmOpen;
      film.showModal(); video.play().catch(() => {});
    });
    $('[data-studio-film-close]', film).addEventListener('click', () => film.close());
    film.addEventListener('close', () => {video.pause(); filmOpener?.focus();});
  }

  const reviews = $('#product-reviews');
  if (reviews) {
    const protectPhotos = () => {
      $$('.jdgm-rev__pics, .jdgm-rev__videos', reviews).forEach((media, index) => {
        if (media.dataset.phProtected) return;
        media.dataset.phProtected = 'true';
        if (!media.id) media.id = 'review-media-' + index;
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'review-photo-gate';
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-controls', media.id);
        button.textContent = copy.experiences.show;
        button.addEventListener('click', () => {
          const reveal = button.getAttribute('aria-expanded') !== 'true';
          media.dataset.revealed = String(reveal);
          button.setAttribute('aria-expanded', String(reveal));
          button.textContent = reveal ? copy.experiences.hide : copy.experiences.show;
        });
        media.before(button);
      });
    };
    new MutationObserver(protectPhotos).observe(reviews, {childList:true, subtree:true});
    protectPhotos();
  }

  const experiences = $('[data-experiences]');
  if (experiences) {
    $$('[data-experience-filter]', experiences).forEach(button => button.addEventListener('click', () => {
      const filter = button.dataset.experienceFilter;
      $$('[data-experience-filter]', experiences).forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      $$('[data-experience-card]', experiences).forEach(card => { card.hidden = filter !== 'all' && card.dataset.experienceProduct !== filter; });
    }));
    experiences.addEventListener('click', event => {
      const reveal = event.target.closest('[data-sensitive-reveal]');
      if (reveal) {
        const stage = reveal.closest('[data-sensitive-stage]');
        const expanded = reveal.getAttribute('aria-expanded') === 'true';
        const content = $('[data-sensitive-content]', stage);
        if (!expanded) {
          $$('[data-sensitive-src]', content).forEach(img => { img.src = img.dataset.sensitiveSrc; img.removeAttribute('data-sensitive-src'); });
        }
        reveal.setAttribute('aria-expanded', String(!expanded));
        $('.sensitive-label', reveal).textContent = expanded ? copy.experiences.show : copy.experiences.hide;
        content.hidden = expanded;
        $('[data-sensitive-cover]', stage).hidden = !expanded;
        stage.classList.toggle('is-revealed', !expanded);
      }
      const play = event.target.closest('[data-experience-play]');
      if (play) {
        const holder = play.closest('[data-experience-video]');
        const video = $('video', holder);
        if (!video.src) video.src = video.dataset.videoSrc;
        video.hidden = false;
        play.hidden = true;
        video.play().catch(() => {});
      }
    });
  }
})();
